import React from "react";
import { usePPTState } from "tap/store/ppt/usePPT";
import { PPTSeverityBadge } from "../PPTSeverityBadge";
import styles from "./styles.module.scss";

export const PPTPromotionIssueList = () => {
  // Get hierarchical issues data from Redux store
  const {
    promotionIssuesData,
    promotionIssuesLoading: loading = false,
    promotionIssuesError: error = null,
  } = usePPTState();

  // Do not display when loading or if there are no issues
  if (!promotionIssuesData || promotionIssuesData.totalIssues === 0) {
    return null;
  }

  const { totalIssues, maxSeverity, promotionLevel = [] } = promotionIssuesData;

  // Flatten the grouped issues for display
  const allIssues = promotionLevel.flatMap(
    (typeGroup) => typeGroup.issues || [],
  );

  return (
    <section
      className={`${styles.issuesSection} ${
        maxSeverity
          ? styles[`background-${maxSeverity.toLowerCase()}`]
          : styles["background-info"]
      }`}
    >
      <div className={styles.header}>
        <h3>Promotion Issues ({totalIssues})</h3>
      </div>
      <ul className={styles.issueList}>
        {allIssues.map((issue) => (
          <li key={issue.id} className={styles.issue}>
            <div className={styles.issueHeader}>
              <PPTSeverityBadge severity={issue.severity} />
              <span>{issue.description}</span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
